import { ErrorSnackbar } from './ErrorSnackbar'
import { InfoSnackbar } from './InfoSnackbar'
import { SuccessSnackbar } from './SuccessSnackbar'
import { WarningSnackbar } from './WarningSnackbar'

export function Snackbars() {
  return (
    <>
      <SuccessSnackbar />
      <InfoSnackbar />
      <ErrorSnackbar />
      <WarningSnackbar />
    </>
  )
}
